import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

// ============================================================================
// DTOs (mirror src/Allmark.Contracts/Companies)
//
// Wire-format casing: ASP.NET Core System.Text.Json default = camelCase.
// ============================================================================

export interface Company {
  id: number;
  companyName: string;
  departmentName: string | null;
  accountsContactClientId: number | null;
  invoiceEmail: string | null;
  plainPackaging: boolean;
  hasApprovedCreditAccount: boolean;
  deleted: boolean;
  accountsContactName: string | null;
  accountsCCEmailAddress: string | null;
}

export interface UpsertCompany {
  companyName: string;
  departmentName?: string | null;
  accountsContactClientId?: number | null;
  invoiceEmail?: string | null;
  plainPackaging: boolean;
  hasApprovedCreditAccount: boolean;
  accountsCCEmailAddress?: string | null;
}

export const companiesApi = {
  get: (id: number) => apiFetch<Company>(`/api/companies/${id}`),
  patch: (id: number, body: UpsertCompany) =>
    apiFetch<Company>(`/api/companies/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  list: (qs = "page=0&pageSize=50") =>
    apiFetch<PagedResult<Company>>(`/api/companies?${qs}`),
};
